import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=1432a7aa"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1432a7aa')) {
      api.createRecord('1432a7aa', component.options)
    } else {
      api.reload('1432a7aa', component.options)
    }
    module.hot.accept("./MessageList.vue?vue&type=template&id=1432a7aa", function () {
      api.rerender('1432a7aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/feedback/MessageList.vue"
export default component.exports